import { defineMessages } from 'react-intl';

const messages: {
	acceptAIPrediction: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	acceptPrediction: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	acknowledge: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	acknowledgeAll: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	addNote: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	addResponder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	addTag: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	ariaLiveMessageFilters: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	assign: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	assignToMe: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	buttonAriaLabelToIndicateTableModification: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	close: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	closeAll: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dareAIViewDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dareAIViewTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	delete: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	deleteAll: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	deleteModalDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	deleteModalTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	empty: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	emptyAIViewDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	emptyAIViewTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	emptyDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	error: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	escalateToNext: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	filterInfo: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	learnMore: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	moreAriaLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	noAlerts: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	noAlertsDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	notEnabledAIViewDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	notEnabledAIViewTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	pageTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	readMoreAlertGrouping: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	reopen: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	requiredFieldsInformMessage: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	snooze: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	snoozeAll: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	snrAccept: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	snrAdd: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	snrAddNoise: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	snrAddSignal: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	snrUpdate: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	snrUpdateNoise: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	snrUpdateSignal: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	successTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	summaryMoreAriaLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	takeOwnership: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unacknowledge: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	errorTitle: {
		id: 'eoc.alert-list.flag.error-title',
		defaultMessage: 'Error',
		description: 'Title of error message that will be displayed in the flag',
	},
	successTitle: {
		id: 'eoc.alert-list.flag.success-title',
		defaultMessage: 'Success',
		description: 'Title of success message that will be displayed in the flag',
	},
	acknowledge: {
		id: 'eoc.alert-list.actions.acknowledge',
		defaultMessage: 'Ack',
		description: 'Button label to acknowledge an alert in the alert list actions menu.',
	},
	reopen: {
		id: 'eoc.alert-list.actions.reopen',
		defaultMessage: 'Reopen',
		description: 'Button label to reopen a closed alert in the alert list actions menu.',
	},
	unacknowledge: {
		id: 'eoc.alert-list.actions.unacknowledge',
		defaultMessage: 'Open',
		description: 'Unacknowledge(open) action button',
	},
	snooze: {
		id: 'eoc.alert-list.actions.snooze',
		defaultMessage: 'Snooze',
		description: 'Button label to snooze an alert in the alert list actions menu.',
	},
	close: {
		id: 'eoc.alert-list.actions.close',
		defaultMessage: 'Close',
		description: 'Button label to close an alert in the alert list actions menu.',
	},
	delete: {
		id: 'eoc.alert-list.actions.delete',
		defaultMessage: ' Delete',
		description: 'Button label to delete an alert in the alert list actions menu.',
	},
	escalateToNext: {
		id: 'eoc.alert-list.actions.escalateToNext',
		defaultMessage: 'Escalate to next',
		description: 'Escalate to next action button',
	},
	assign: {
		id: 'eoc.alert-list.actions.assign',
		defaultMessage: 'Assign',
		description: 'Button label to assign an alert to a user in the alert list actions menu.',
	},
	addResponder: {
		id: 'eoc.alert-list.actions.add-responder',
		defaultMessage: 'Add responder',
		description: 'Button label to add a responder to an alert in the alert list actions menu.',
	},
	takeOwnership: {
		id: 'eoc.alert-list.actions.takeOwnership',
		defaultMessage: 'Assign to me',
		description:
			'Button label to assign an alert to the current user in the alert list actions menu.',
	},
	addTag: {
		id: 'eoc.alert-list.actions.add-tag',
		defaultMessage: 'Add tag',
		description: 'Button label to add a tag to an alert in the alert list actions menu.',
	},
	addNote: {
		id: 'eoc.alert-list.actions.add-note',
		defaultMessage: 'Add note',
		description: 'Button label to add a note to an alert in the alert list actions menu.',
	},
	empty: {
		id: `eoc.alert-list.empty`,
		defaultMessage: 'We couldn’t find any alerts matching your search',
		description:
			'Alerts can be symptoms of potential incidents or issues. Integrate your applications so you never miss a critical alert.',
	},
	noAlerts: {
		id: `eoc.alert-list.no-alerts`,
		defaultMessage: 'You don’t have any alerts, yet',
		description: 'Message displayed when there is no alerts',
	},
	learnMore: {
		id: `eoc.alert-list.no-alerts.learn-more`,
		defaultMessage: 'Read how alerts are created',
		description: 'Message displayed for redirecting user to alert create docs',
	},
	emptyDescription: {
		id: `eoc.alert-list.no-alerts.description`,
		defaultMessage:
			'Adjust your search filters and try again. You can also create an alert to notify your team about anything critical.',
		description: 'Message displayed as description when there is no alerts with given search',
	},
	noAlertsDescription: {
		id: `eoc.alert-list.no-alerts.description`,
		defaultMessage:
			'Alerts can be symptoms of potential incidents or issues. Integrate your applications so you never miss a critical alert.',
		description: 'Message displayed when there is no alerts',
	},
	error: {
		id: `eoc.alert-list.error`,
		defaultMessage: 'We couldn’t load the alerts',
		description: 'Message displayed when there is an error on fetching alerts',
	},
	errorDescription: {
		id: `eoc.alert-list.error.description`,
		defaultMessage: 'Something went wrong while we were loading the alerts. Try searching again.',
		description: 'Message displayed as description when there is an error on fetching alerts',
	},
	pageTitle: {
		id: 'eoc.alert-list.page.title',
		defaultMessage: 'Alerts',
		description: 'Page title displayed in the browser tab for the alerts list page.',
	},
	emptyAIViewTitle: {
		id: 'eoc.alert-list.flag.error-title',
		defaultMessage: 'Looking for alerts to group',
		description: 'Title ofthe message that will be displayed when no groups are present',
	},
	emptyAIViewDescription: {
		id: 'eoc.alert-list.flag.success-title',
		defaultMessage:
			'Rovo is working behind the scenes and will update this space as soon as new groups are identified.',
		description: 'Description of the message that will be displayed when no groups are present',
	},
	dareAIViewTitle: {
		id: 'eoc.alert-list.flag.dare-title',
		defaultMessage: 'Starting fresh to group alerts',
		description:
			'Title of the message that will be displayed when no groups are present because of DaRe',
	},
	dareAIViewDescription: {
		id: 'eoc.alert-list.flag.dare-description',
		defaultMessage:
			'Since you changed your data residency location, previous alert groups were deleted. Rovo is working behind the scenes and will update this space as soon as new groups are identified.',
		description: 'Description of the message that will be displayed when no groups are present',
	},
	notEnabledAIViewTitle: {
		id: 'eoc.smart-alert-list.flag.not-enabled',
		defaultMessage: 'We couldn’t find what you’re looking for',
		description: 'Title of the message that will be displayed when AI view is not enabled',
	},
	notEnabledAIViewDescription: {
		id: 'eoc.smart-alert-list.flag.not-enabled',
		defaultMessage: 'We looked everywhere, but it doesn’t exist.',
		description: 'Description of the message that will be displayed when AI view is not enabled',
	},
	readMoreAlertGrouping: {
		id: 'eoc.alert-list.flag.success-title',
		defaultMessage: 'Read more about alert grouping',
		description: 'Message for read more that will be displayed when no groups are present',
	},
	requiredFieldsInformMessage: {
		id: 'eoc.alert-list.modal.required-fields-inform-message',
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'Message to give information to users about required fields',
	},
	ariaLiveMessageFilters: {
		id: `eoc.alert-list.filters.aria-live-message`,
		defaultMessage: `{removedValue, select,
      true { Option {label} deselected. {numOfAlerts} matching alerts found. }
      other { Option {label} selected. {numOfAlerts} matching alerts found. }
    }`,
		description: 'The message to be announced when user selects an option from one of the filters.',
	},
	buttonAriaLabelToIndicateTableModification: {
		id: `eoc.alert-list.filters.update-button`,
		defaultMessage: '{buttonText}. The table will be modified.',
		description: 'The message to be announced before user press update filter button.',
	},
	acceptAIPrediction: {
		id: 'eoc.alert-list.unified-bulk-actions.accept-ai-prediction',
		defaultMessage: 'Accept classification',
		description: 'Button label for accepting AI prediction in bulk actions',
	},
	acknowledgeAll: {
		id: 'eoc.unified-list.actions.acknowledge',
		defaultMessage: 'Ack all',
		description:
			'The text is shown on a bulk action button in the alert list toolbar that acknowledges all selected alerts at once.',
	},
	snoozeAll: {
		id: 'eoc.unified-list.actions.snooze',
		defaultMessage: 'Snooze all',
		description:
			'The text is shown on a bulk action button in the alert list toolbar that snoozes all selected alerts at once.',
	},
	closeAll: {
		id: 'eoc.unified-list.actions.close',
		defaultMessage: 'Close all',
		description:
			'The text is shown on a bulk action button in the alert list toolbar that closes all selected alerts at once.',
	},
	deleteAll: {
		id: 'eoc.unified-list.actions.delete',
		defaultMessage: 'Delete all',
		description:
			'The text is shown on a bulk action button in the alert list toolbar that deletes all selected alerts at once.',
	},
	assignToMe: {
		id: 'eoc.unified-list.actions.assignToMe',
		defaultMessage: 'Assign to me',
		description:
			'The text is shown on a bulk action button in the alert list toolbar that assigns all selected alerts to the currently signed-in user.',
	},
	acceptPrediction: {
		id: 'eoc.unified-list.actions.acceptPrediction',
		defaultMessage: 'Accept classification',
		description:
			'The text is shown on a bulk action button in the alert list toolbar that accepts the ML-suggested noise classification for all selected alerts.',
	},
	moreAriaLabel: {
		id: 'eoc.unified-list.actions.more-aria-label',
		defaultMessage: 'More actions for {tinyId}',
		description:
			'The text is shown as the aria-label on the "More actions" menu button in each alert list row. The placeholder {tinyId} will be substituted with the short identifier of the alert (e.g. "P-123").',
	},
	summaryMoreAriaLabel: {
		id: 'eoc.alert-list.summary-actions.more-aria-label',
		defaultMessage: 'More actions for alert {tinyId}',
		description: 'Aria label for the more actions button in summary',
	},
	deleteModalTitle: {
		id: 'eoc.alert-list.summary-actions.delete-modal-title',
		defaultMessage: 'Delete alert',
		description:
			'The text is shown as the heading of the delete confirmation modal dialog that appears when a user requests to delete an alert from the alert list.',
	},
	deleteModalDescription: {
		id: 'eoc.alert-list.summary-actions.delete-modal-description',
		defaultMessage: 'Are you sure you want to delete this alert? This action cannot be undone.',
		description: 'Description for the delete confirmation modal',
	},
	filterInfo: {
		id: 'eoc.alert-list.header.filter-info',
		defaultMessage:
			"The results include groups that have alerts matching your filter criteria. The group's overall priority may differ.",
		description: 'Filter info in the alert smart table header',
	},
	snrAdd: {
		id: 'eoc.alert-list.actions.snr-add',
		defaultMessage: 'Classify',
		description:
			'The text is shown on an action button in the alert list that opens a dialog to classify an alert using the signal-to-noise ratio (SNR) classification feature.',
	},
	snrAddSignal: {
		id: 'eoc.alert-list.actions.snr-add-signal',
		defaultMessage: 'Classify as signal',
		description: 'SNR Add classification as signal action button',
	},
	snrAddNoise: {
		id: 'eoc.alert-list.actions.snr-add-noise',
		defaultMessage: 'Classify as noise',
		description: 'SNR Add classification as noise action button',
	},
	snrUpdate: {
		id: 'eoc.alert-list.actions.snr-update',
		defaultMessage: 'Update classification',
		description:
			'The text is shown on an action button in the alert list that opens a dialog to update an existing SNR noise classification for an alert.',
	},
	snrUpdateSignal: {
		id: 'eoc.alert-list.actions.snr-update-signal',
		defaultMessage: 'Update as signal',
		description: 'SNR Update classification as signal action button',
	},
	snrUpdateNoise: {
		id: 'eoc.alert-list.actions.snr-update-noise',
		defaultMessage: 'Update as noise',
		description: 'SNR Update classification as noise action button',
	},
	snrAccept: {
		id: 'eoc.alert-list.actions.snr-accept',
		defaultMessage: 'Accept classification',
		description:
			'The text is shown on an action button in the alert list that accepts the ML-suggested SNR noise classification for a single alert.',
	},
});

export default messages;
